import React from "react";
import axios from "axios";

import { useTrainer, useTrainerGroupsOptions } from "../../api/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { TrainerForm, TrainerFormValues } from "./TrainerForm/TrainerForm";
import { routes } from "consts";
import { trainersApi } from "api";
import { useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";

export const TrainersEditPage = (): JSX.Element | null => {
  const { trainerId } = useParams();
  const { showSuccess, showError } = useToaster();
  const navigate = useNavigate();
  const { loading: loadingTrainer, data: trainer } = useTrainer(Number(trainerId));
  const { loading: loadingGroups, options } = useTrainerGroupsOptions();

  if (loadingTrainer || loadingGroups) return null;

  const breadcrumbs = [
    { title: "Trenerzy", path: routes.TRAINERS },
    { title: `${trainer?.firstName} ${trainer?.surname}`, path: routes.TRAINER(trainerId) },
    { title: "Edytuj" },
  ];

  const onSubmit = async (data: TrainerFormValues) => {
    try {
      await trainersApi.update(Number(trainerId), data);
      showSuccess("Trener został zaktualizowany");
      navigate(routes.TRAINER(trainerId));
    } catch (error) {
      console.error(error);
      // Np. konflikt adresu e-mail przy synchronizacji konta trenera - API zwraca opis w ProblemDetails.title
      const apiMessage = axios.isAxiosError(error) ? error.response?.data?.title : undefined;
      showError(typeof apiMessage === "string" ? apiMessage : "Nie udało się zaktualizować trenera");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj trenera" />
      <TrainerForm groupsOptions={options} trainer={trainer} onSubmit={onSubmit} />
    </PageMain>
  );
};
